import { render, staticRenderFns } from "./LapsedCustomers.vue?vue&type=template&id=1bde8a95&"
import script from "./LapsedCustomers.vue?vue&type=script&lang=js&"
export * from "./LapsedCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports